import { render, staticRenderFns } from "./UseMultipleCouponsDialog.vue?vue&type=template&id=f75ac0d8&scoped=true"
import script from "./UseMultipleCouponsDialog.vue?vue&type=script&lang=ts"
export * from "./UseMultipleCouponsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75ac0d8",
  null
  
)

export default component.exports